const initialvalues = {
    payment: "",
    setOwnerDetailsbyRadio: [],
    setfilterOwnerDetailsbyRadio: [],
    setDueDetails: [],
    bakFlag: false,
    backFlag1: "fresh",
    formikValues: {},
    houseTaxSecVillValues: {},
    cfmsBankDetails: {},
    cfmsPaymentType: "",
    backflagpartial:false,
    setDueDetailsUpdated:[]

}

export default function PaymentReducer(details = initialvalues, action) {

    switch (action.type) {
        case "PAYMENT":
            return { ...details, payment: action.payload };

        case "SETOWNERDETAILSBYRADIO":
            return { ...details, setOwnerDetailsbyRadio: action.payload };
        case "SETFILTEROWNERDETAILSBYRADIO":
            return { ...details, setfilterOwnerDetailsbyRadio: action.payload };
        case "SETDUEDETAILS":
            return { ...details, setDueDetails: action.payload };

        case "FORMIKVALUES":
            return { ...details, formikValues: action.payload };
        case "BACKFLAG":
            return { ...details, bakFlag: action.payload };
        case "BACKFLAG1":
            return { ...details, bakFlag1: action.payload };
        case "HOUSETAXSECVILLVALUES":
            return { ...details, houseTaxSecVillValues: action.payload };
        case "CFMSPAYMENTTYPE":
            return { ...details, cfmsPaymentType: action.payload };
             case "BACKFLAGPARTIAL":
            return { ...details, backflagpartial: action.payload };
            case "SETDUEDETAILSUPDATED":
            return { ...details,setDueDetailsUpdated: action.payload };



        default:
            return details;
    }
}